module.exports = __webpack_public_path__ + "media/application/images/ui/endorsement_peoples-choice-da1f6b2afd35e5714e4b12b539ae466c.svg";